import { apiService } from './api';
import { buildApiUrl } from './config';

export type TipoAutomatico = 'erro_conferente' | 'duplicata_cliente' | 'palete_nao_utilizado';

export interface TipoOcorrenciaDivergencia {
  id: number;
  empresa_id: number;
  nome: string;
  codigo: string;
  descricao: string | null;
  ativo: boolean;
  automatico: boolean;
  tipo_automatico: TipoAutomatico | null;
  ocorrencia_de_corte: boolean;
  criado_em: string;
  atualizado_em: string;
}

export async function listarTiposOcorrencia(apenasAtivos = false, excluirAutomaticos = false): Promise<{ success: boolean; tipos: TipoOcorrenciaDivergencia[] }> {
  const params = new URLSearchParams();
  if (apenasAtivos) params.set('apenas_ativos', 'true');
  if (excluirAutomaticos) params.set('excluir_automaticos', 'true');
  const qs = params.toString();
  const url = buildApiUrl(`/tipos-ocorrencia-divergencia${qs ? `?${qs}` : ''}`);
  return apiService.request(url);
}

export async function criarTipoOcorrencia(data: {
  nome: string;
  codigo: string;
  descricao?: string;
  ativo?: boolean;
  automatico?: boolean;
  tipo_automatico?: TipoAutomatico | null;
  ocorrencia_de_corte?: boolean;
}): Promise<{ success: boolean; data: TipoOcorrenciaDivergencia; message: string }> {
  const url = buildApiUrl('/tipos-ocorrencia-divergencia');
  return apiService.request(url, { method: 'POST', body: JSON.stringify(data) });
}

export async function atualizarTipoOcorrencia(id: number, data: {
  nome?: string;
  codigo?: string;
  descricao?: string;
  ativo?: boolean;
  automatico?: boolean;
  tipo_automatico?: TipoAutomatico | null;
  ocorrencia_de_corte?: boolean;
}): Promise<{ success: boolean; data: TipoOcorrenciaDivergencia; message: string }> {
  const url = buildApiUrl(`/tipos-ocorrencia-divergencia/${id}`);
  return apiService.request(url, { method: 'PUT', body: JSON.stringify(data) });
}

export async function deletarTipoOcorrencia(id: number): Promise<{ success: boolean; message: string }> {
  const url = buildApiUrl(`/tipos-ocorrencia-divergencia/${id}`);
  return apiService.request(url, { method: 'DELETE' });
}
